<template>
  <span class="chip" :class="tones[tone]">
    <span class="h-1.5 w-1.5 rounded-full bg-current" />
    {{ label }}
  </span>
</template>

<script>
import { TONES, enumLabel, enumTone } from '@/utils/labels'

export default {
  name: 'StatusBadge',
  props: {
    /** Nom de l'énumération (ex. paymentStatus) — voir utils/labels.js. */
    enumName: { type: String, required: true },
    value: { type: String, default: '' }
  },
  computed: {
    label() {
      return enumLabel(this.enumName, this.value)
    },
    tone() {
      return enumTone(this.enumName, this.value)
    },
    tones() {
      return TONES
    }
  }
}
</script>
